var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card box-card" },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm._l(_vm.incidents, function(incident) {
        return [
          _c("div", { key: incident.opened, staticClass: "card-group" }, [
            _c("div", { staticClass: "card alert-card" }, [
              _c(
                "div",
                {
                  staticClass: "card-heading alert-heading d-flex",
                  attrs: {
                    "data-toggle": "collapse",
                    href: "#id-" + incident.opened
                  }
                },
                [
                  _c("h6", { staticClass: "card-title" }, [
                    _c("strong", [_vm._v("Opened: ")]),
                    _vm._v(
                      _vm._s(
                        _vm._f("moment")(incident.opened, "MMM Do, h:mm a")
                      ) + "\n            "
                    ),
                    _c("strong", [_vm._v("Closed: ")]),
                    _vm._v(
                      _vm._s(
                        _vm._f("moment")(incident.closed, "MMM Do, h:mm a")
                      ) + "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("h6", { staticClass: "ml-auto" }, [
                    _vm._v(_vm._s(_vm.friendlyDuration(incident.close_time)))
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "card-collapse collapse",
                  attrs: { id: "id-" + incident.opened }
                },
                _vm._l(incident.alerts, function(alert, index) {
                  return _c(
                    "ul",
                    {
                      key: incident.opened + "-" + index,
                      staticClass: "list-group list-group-flush"
                    },
                    [
                      _c("li", { staticClass: "list-group-item" }, [
                        _c("div", { staticClass: "alert-name" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(alert.name) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "alert-details" }, [
                          _c("strong", [_vm._v("Opened: ")]),
                          _vm._v(
                            _vm._s(
                              _vm._f("moment")(alert.opened, "MMM Do, h:mm a")
                            ) + "\n                "
                          ),
                          _c("span", [_vm._v("  ")]),
                          _vm._v(" "),
                          _c("strong", [_vm._v("Closed: ")]),
                          _vm._v(
                            _vm._s(
                              _vm._f("moment")(alert.closed, "MMM Do, h:mm a")
                            ) + "\n                "
                          ),
                          _c("span", [_vm._v("  ")]),
                          _vm._v(" "),
                          _c("strong", [_vm._v("Time: ")]),
                          _vm._v(
                            _vm._s(_vm.friendlyDuration(alert.close_time)) +
                              "\n              "
                          )
                        ])
                      ])
                    ]
                  )
                }),
                0
              )
            ])
          ])
        ]
      })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-heading" }, [
      _c("h4", { staticClass: "card-title text-center" }, [_vm._v("Incidents")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75ad87f9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75ad87f9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Alerts/Incidents.vue
// module id = null
// module chunks = 